import {
  LotterySchema,
  PartyUidSchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type AddParticipantsParams = Static<typeof AddParticipantsParamsSchema>;
export const AddParticipantsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'AddParticipantsParamsSchema' }
);

export type AddParticipantsBody = Static<typeof AddParticipantsBodySchema>;
export const AddParticipantsBodySchema = Type.Object(
  {
    newParticipants: Type.Array(
      Type.Object(
        {
          partyUid: PartyUidSchema,
          entryDate: Type.String({ format: 'date' }),
        },
        { additionalProperties: false }
      ),
      { minItems: 1, maxItems: 1000 }
    ),
  },
  { additionalProperties: false, $id: 'AddParticipantsBodySchema' }
);

export type AddParticipantsResponse = Static<typeof AddParticipantsResponseSchema>;
export const AddParticipantsResponseSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'AddParticipantsResponseSchema' }
);
